import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Field, Formik } from "formik";
import { Modal } from "react-bootstrap";
import { Input, Select } from "../../../../../_metronic/_partials/controls";
import { findDistrict } from "../../../MasterData/_redux/province/provinceCrud";
import AsyncSelect from "react-select/async";
import { genOptionLoaderDebounced } from "../../../../../_metronic/_helpers/fetchUtils";
import {
  findBenefisCategory,
  getBenefisCategoryAll
} from "../../../BenefisCategory/_redux/benefisCategory/benefisCategoryCrud";
import * as Yup from "yup";
import { toast } from "react-toastify";

const BenefisSchema = Yup.object().shape({
  email: Yup.string().email("Email tidak valid")
});

export default function ModalEditBenefis({
  initValues = {
    data: {}
  },
  onSubmit,
  show,
  onHide
}) {
  const [district, setDistrict] = useState([]);
  const [kotaValue, setKotaValue] = useState("");
  const [benefis_category, setBenefisCategory] = useState([]);
  const [postalCode, setPostalCode] = useState([]);

  useEffect(() => {
    getBenefisCategoryAll()
      .then(res => {
        return setBenefisCategory(
          res.data.data.map(item => ({
            value: item.uuid,
            label: `${item.name} - ${item.uuid}`
          }))
        );
      })
      .catch(err => {
        toast.error("Gagal mengambil data kategori benefis");
      });
  }, []);

  useEffect(() => {
    if (show) {
      // * Initial Address
      if (
        initValues?.data?.district &&
        initValues?.data?.city &&
        initValues?.data?.province
      ) {
        setKotaValue(
          `${initValues?.data?.district}, ${initValues?.data?.city}, ${initValues?.data?.province}`
        );
      }
      // eslint-disable-next-line
    } else {
      setKotaValue("");
    }
  }, [initValues]);

  const onInputChange = e => {
    const value = e.target.value;

    if (value.length >= 3) {
      let query = {
        district: value,
        city: value
      };
      findDistrict(query).then(response => {
        setDistrict(response.data.data);
      });
    }
  };

  const onSelectTag = (value, setFieldValue) => {
    if (value) {
      const array = value.split(",");
      if (array.length === 3) {
        let index = district.findIndex(
          i =>
            i.district === array[0].trim() &&
            i.city === array[1].trim() &&
            i.province_name === array[2].trim()
        );

        setPostalCode(district[index].postalcode);

        setFieldValue("province", district[index].province_name);
        setFieldValue("city", district[index].city);
        setFieldValue("district", district[index].district);
        setKotaValue(
          `${district[index].district}, ${district[index].city}, ${district[index].province_name}`
        );
      }
    } else {
      setFieldValue("province", "");
      setFieldValue("city", "");
      setFieldValue("district", "");
      setKotaValue("");
      setFieldValue("postal_code", "");
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          name: initValues?.data?.name,
          hp: initValues?.data?.hp,
          email: initValues?.data?.email,
          nik: initValues?.data?.nik,
          benefis_category_uuid: initValues?.data?.benefis_category_uuid,
          benefis_category_name: initValues?.data?.benefis_category_name,
          benefis_category: initValues?.data?.benefis_category,
          province: initValues?.data?.province,
          city: initValues?.data?.city,
          district: initValues?.data?.district,
          postal_code: initValues?.data?.postal_code,
          is_alive: initValues?.data?.is_alive,
          is_active: initValues?.data?.is_active
        }}
        onSubmit={values => onSubmit({ ...values, key: initValues?.data?.key })}
        validationSchema={BenefisSchema}
      >
        {({
          setFieldValue,
          values,
          handleBlur,
          handleSubmit,
          handleChange
        }) => {
          return (
            <>
              <Modal size="lg" show={show} onHide={onHide}>
                <Modal.Header>
                  <Modal.Title>Edit Benefis Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="form-group row">
                    <div className="col">
                      <h4>Error List</h4>
                      <ul>
                        {initValues?.errors ? (
                          Object.keys(initValues?.errors).map(key => {
                            return initValues?.errors[key] ? (
                              <li style={{ color: "red" }}>
                                {initValues?.errors[key]}
                              </li>
                            ) : null;
                          })
                        ) : (
                          <li>There is no error</li>
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col">
                      <label>Nama</label>
                      <Field
                        component={Input}
                        name="name"
                        placeholder="Nama"
                        onBlur={handleBlur}
                        withFeedbackLabel={false}
                      />
                    </div>
                    <div className="col">
                      <label>HP</label>
                      <input
                        type="text"
                        className="form-control"
                        value={values.hp}
                        onChange={e => {
                          if (e.target.value.match(/^[0-9]*$/)) {
                            setFieldValue("hp", e.target.value);
                          }
                        }}
                        name="hp"
                        placeholder="Nomor Telepon"
                        onBlur={handleBlur}
                        withFeedbackLabel={false}
                      />
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col">
                      <label>Email</label>
                      <Field
                        component={Input}
                        name="email"
                        placeholder="Email"
                        onBlur={handleBlur}
                        withFeedbackLabel={false}
                      />
                    </div>
                    <div className="col">
                      <label>Ktp</label>
                      <input
                        type="text"
                        className="form-control"
                        value={values.nik}
                        onChange={e => {
                          if (e.target.value.match(/^[0-9]*$/)) {
                            setFieldValue("nik", e.target.value);
                          }
                        }}
                        name="nik"
                        placeholder="NIK / No Perusahaan"
                        onBlur={handleBlur}
                        withFeedbackLabel={false}
                      />
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col-lg-8">
                      <Autocomplete
                        id="searchPostalCode"
                        onChange={(e, value) => {
                          onSelectTag(value, setFieldValue);
                        }}
                        value={kotaValue}
                        options={district.map(
                          option =>
                            `${option.district}, ${option.city}, ${option.province_name}`
                        )}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label="Cari Kota / Kecamatan"
                            margin="normal"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              type: "search"
                            }}
                            onChange={e => {
                              onInputChange(e);
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-lg-4">
                      <Select
                        name="postal_code"
                        label="Kodepos"
                        value={values.postal_code}
                      >
                        <option value="">-PILIH-</option>
                        {values.postal_code && (
                          <option value={values.postal_code}>
                            {values.postal_code}
                          </option>
                        )}
                        {postalCode.map(row => (
                          <option key={row} value={row}>
                            {row}
                          </option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-12">
                      <label>
                        <strong>Kategori Penerima Manfaat</strong>
                      </label>
                      <AsyncSelect
                        defaultOptions={benefis_category}
                        loadOptions={genOptionLoaderDebounced(
                          inputValue =>
                            findBenefisCategory({
                              pageNumber: 1,
                              pageSize: 10,
                              filter: {
                                name: inputValue
                              }
                            }),
                          ({ uuid, name }) => ({
                            label: `${name} - ${uuid}`,
                            value: uuid
                          })
                        )}
                        value={
                          values.benefis_category_uuid
                            ? {
                                label: `${values.benefis_category_name} - ${values.benefis_category_uuid}`,
                                value: values.benefis_category_uuid
                              }
                            : null
                        }
                        placeholder="Pilih Kategori Penerima Manfaat"
                        onChange={e => {
                          const { value, label } = e ?? {};
                          setFieldValue("benefis_category_uuid", value);
                          setFieldValue(
                            "benefis_category_name",
                            label?.split("-")[0]?.trim()
                          );
                          setFieldValue("benefis_category", label);
                        }}
                        isClearable
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-6">
                      <label>
                        <strong>Status Hidup</strong>
                      </label>
                      <select
                        className="form-control"
                        name="is_alive"
                        value={values.is_alive}
                        onChange={handleChange}
                      >
                        <option value="">-PILIH-</option>
                        <option value="Hidup">Hidup</option>
                        <option value="Meninggal">Meninggal</option>
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label>
                        <strong>Status Aktif</strong>
                      </label>
                      <select
                        className="form-control"
                        name="is_active"
                        value={values.is_active}
                        onChange={handleChange}
                      >
                        <option value="">-PILIH-</option>
                        <option value="Aktif">Aktif</option>
                        <option value="Tidak Aktif">Tidak Aktif</option>
                      </select>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button className="btn btn-primary" onClick={handleSubmit}>
                    Simpan
                  </button>
                </Modal.Footer>
              </Modal>
            </>
          );
        }}
      </Formik>
    </>
  );
}
